import isNil from 'lodash/isNil';
import { industriesMapping } from 'shared/mappings/industries/industriesMapping';

export const parseIndustriesMapping = classification =>
  Array.isArray(classification) &&
  classification
    .map(({ sectors }) => sectors)
    .flat()
    .reduce(
      (obj, item) => ({
        ...obj,
        [item.code]: item.name,
      }),
      {},
    );

export const parseIndustryType = industryType => {
  if (isNil(industryType)) return null;

  return (
    (industryType.length === 4 &&
      industryType === industryType.toUpperCase() &&
      industriesMapping[industryType]) ||
    industryType
  );
};
